import { render } from "./characterCreator.vue?vue&type=template&id=5d9f5e78&scoped=true"
import script from "./characterCreator.vue?vue&type=script&lang=js"
export * from "./characterCreator.vue?vue&type=script&lang=js"

import "./characterCreator.vue?vue&type=style&index=0&id=5d9f5e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9f5e78"]])

export default __exports__